export default __webpack_public_path__ + "static/media/season-sticks.f92c873c.svg";